import { render, staticRenderFns } from "./CadastroInternacional.vue?vue&type=template&id=1c53b9d2&scoped=true&"
import script from "./CadastroInternacional.vue?vue&type=script&lang=js&"
export * from "./CadastroInternacional.vue?vue&type=script&lang=js&"
import style0 from "./CadastroInternacional.vue?vue&type=style&index=0&id=1c53b9d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53b9d2",
  null
  
)

export default component.exports